import { render } from "./ClientePagoList.vue?vue&type=template&id=39b76da1&scoped=true"
import script from "./ClientePagoList.vue?vue&type=script&lang=js"
export * from "./ClientePagoList.vue?vue&type=script&lang=js"

import "./ClientePagoList.vue?vue&type=style&index=0&id=39b76da1&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b76da1"]])

export default __exports__